export default __webpack_public_path__ + "static/media/AG.9d1a151c.svg";